(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["bn-collection-header"] && !Shopify.designMode) return;
  try {
    
  (() => {
    const heroCount = document.querySelector('.bn-collection-hero [data-bn-collection-count]');
    const gridSection = document.querySelector('results-list')?.closest('.shopify-section');
    if (!heroCount || !gridSection) return;

    const syncCount = () => {
      const label = gridSection.querySelector('[data-testid="products-count"] span')?.textContent || '';
      const digits = label.match(/\d[\d.,\s]*/)?.[0];
      if (!digits) return;
      const count = Number(digits.replace(/\D/g, ''));
      if (!Number.isSafeInteger(count)) return;
      const noun = count === 1 ? heroCount.dataset.bnCountOne : heroCount.dataset.bnCountMany;
      const next = `${heroCount.dataset.bnCountPrefix} ${count} ${noun}`;
      if (heroCount.textContent?.trim() !== next) heroCount.textContent = next;
    };

    new MutationObserver(syncCount).observe(gridSection, { childList: true, characterData: true, subtree: true });
    syncCount();
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-pdp-compare"] && !Shopify.designMode) return;
  try {
    
(function () {
  /* Reveal on scroll */
  var els = document.querySelectorAll('[data-bn-reveal]');
  if (!('IntersectionObserver' in window) || !els.length) {
    els.forEach(function (e) { e.classList.add('bn-in'); });
  } else {
    var io = new IntersectionObserver(function (entries) {
      entries.forEach(function (en) {
        if (en.isIntersecting) { en.target.classList.add('bn-in'); io.unobserve(en.target); }
      });
    }, { threshold: 0.12, rootMargin: '0px 0px -40px 0px' });
    els.forEach(function (e) { io.observe(e); });
  }

  /* Mobile product toggle: swaps which product column is shown beside the labels. */
  document.querySelectorAll('.bn-cmp').forEach(function (sec) {
    var tabs = Array.prototype.slice.call(sec.querySelectorAll('[data-cmp-tab]'));
    if (!tabs.length) { return; }
    function activate(key, focus) {
      sec.setAttribute('data-cmp-active', key);
      tabs.forEach(function (t) {
        var on = t.getAttribute('data-cmp-tab') === key;
        t.setAttribute('aria-pressed', on ? 'true' : 'false');
        t.tabIndex = on ? 0 : -1;
        if (on && focus) { t.focus(); }
      });
    }
    tabs.forEach(function (t, i) {
      t.addEventListener('click', function () { activate(t.getAttribute('data-cmp-tab')); });
      t.addEventListener('keydown', function (e) {
        if (e.key === 'ArrowRight' || e.key === 'ArrowDown') {
          e.preventDefault();
          activate(tabs[(i + 1) % tabs.length].getAttribute('data-cmp-tab'), true);
        } else if (e.key === 'ArrowLeft' || e.key === 'ArrowUp') {
          e.preventDefault();
          activate(tabs[(i - 1 + tabs.length) % tabs.length].getAttribute('data-cmp-tab'), true);
        }
      });
    });
  });
})();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["bn-pdp-lifestyle-banner"] && !Shopify.designMode) return;
  try {
    
  (function () {
    var reduce = window.matchMedia && window.matchMedia('(prefers-reduced-motion: reduce)').matches;

    document.querySelectorAll('[data-bn-lb]').forEach(function (root) {
      if (root.dataset.bnLbInit) return;
      root.dataset.bnLbInit = '1';

      var panel = root.querySelector('[data-bn-lb-reveal]');
      var scale = root.querySelector('[data-bn-lb-scale]');
      var media = root.querySelector('[data-bn-lb-media]');

      if (reduce) return; // CSS already renders the static, fully-visible state.

      // Mark ready so the reveal start-state applies only when JS can finish it.
      root.setAttribute('data-bn-lb-ready', '');

      // Scroll-in reveal.
      if (panel && 'IntersectionObserver' in window) {
        var io = new IntersectionObserver(function (entries) {
          entries.forEach(function (e) {
            if (e.isIntersecting) {
              e.target.classList.add('is-in');
              io.unobserve(e.target);
            }
          });
        }, { threshold: 0.25, rootMargin: '0px 0px -8% 0px' });
        io.observe(panel);
      } else if (panel) {
        panel.classList.add('is-in');
      }

      // Slow parallax-ish background scale driven by scroll position.
      if (scale && media) {
        var ticking = false;
        var update = function () {
          ticking = false;
          var rect = media.getBoundingClientRect();
          var vh = window.innerHeight || document.documentElement.clientHeight;
          if (rect.bottom < 0 || rect.top > vh) return; // off-screen, skip work
          // progress 0 as the banner enters from the bottom, 1 as it exits the top.
          var travel = vh + rect.height;
          var p = (vh - rect.top) / travel;
          p = p < 0 ? 0 : p > 1 ? 1 : p;
          var s = 1.06 - (0.06 * p); // 1.06 -> 1.00
          scale.style.transform = 'scale(' + s.toFixed(4) + ')';
        };
        var onScroll = function () {
          if (!ticking) { ticking = true; window.requestAnimationFrame(update); }
        };
        window.addEventListener('scroll', onScroll, { passive: true });
        window.addEventListener('resize', onScroll, { passive: true });
        update();
      }
    });
  })();

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["main-collection"]) return;
  try {
    
  const url = new URL(window.location.href);
  if (url.hash) {
    document.addEventListener(
      'DOMContentLoaded',
      () => {
        const card = document.getElementById(url.hash.slice(1));
        if (card) {
          card.scrollIntoView({ behavior: 'instant' });
        }
      },
      { once: true }
    );
  }

  } catch(e) { console.error(e); }
})();
})();
